import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'mandates-base-banner',
  templateUrl: './base-banner.component.html',
  styleUrls: ['./base-banner.component.scss']
})
export class BaseBannerComponent {
  @Input() type: 'info' | 'warning' | 'success' | 'error' = 'info';
  @Input() active: boolean = false;
  @Input() message: string = '';
  @Input() link: string | any[] | null | undefined;

  @Output() clicked = new EventEmitter<void>();

  protected get isClickable(): boolean {
    return !!this.link || this.clicked.observed;
  }

  handleClick(): void {
    this.clicked.emit();
  }
}
